import { render, staticRenderFns } from "./TransferenciaOpmeConsignado.vue?vue&type=template&id=bd19699a&"
import script from "./TransferenciaOpmeConsignado.vue?vue&type=script&lang=js&"
export * from "./TransferenciaOpmeConsignado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports